module.exports = "pegasus_template/assets/tech/npo_1/100.png";